import React, { useEffect, useState } from 'react'
import SlidingPanel from 'react-sliding-side-panel'
import { MdKeyboardBackspace } from 'react-icons/md'

import CartItem from './cartItem'
import IconCart from '../../../images/icon-cart.png'

const CartPopup = ({ client }) => {
  const [showPopup, setShowPopup] = useState(false)
  const [cartData, setCartData] = useState()
  const [donateOption, setDonateOption] = useState()

  const getCartInfo = async () => {
    const resCart = await fetch('/cart.js', {
      headers: {
        'Content-Type': 'application/json',
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
      credentials: 'same-origin',
    })
    const data = await resCart.json()
    setDonateOption(
      data.attributes[
        'Where should we donate 50% of the profit from your order?'
      ]
    )
    setCartData(data)
  }

  useEffect(() => {
    getCartInfo()
  }, [])

  useEffect(() => {
    if (showPopup) {
      getCartInfo()
    }
  }, [showPopup])

  const onShowPopup = () => {
    setShowPopup(true)
  }

  const onUpdateItem = async (item, quantity) => {
    const resCart = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        updates: {
          [item.id]: quantity,
        },
      }),
    })

    const data = await resCart.json()
    setCartData(data)
  }

  const onChangeAttribute = async (e) => {
    setDonateOption(e.target.value)
    const resCart = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        pragma: 'no-cache',
        'cache-control': 'no-cache',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: {
          ['Where should we donate 50% of the profit from your order?']:
            e.target.value,
        },
      }),
    })

    const data = await resCart.json()
    setCartData(data)
  }

  return (
    <div>
      <a id='btn_cart' onClick={onShowPopup}>
        <img src={IconCart} alt='cart' />
        {cartData && cartData.item_count > 0 && (
          <span id='cart_count'>{cartData ? cartData.item_count : 0}</span>
        )}
      </a>
      <SlidingPanel
        type={'right'}
        isOpen={showPopup}
        backdropClicked={() => {
          setShowPopup(false)
        }}
      >
        <div className='panel-header'>
          <p>
            <span
              onClick={() => {
                setShowPopup(false)
              }}
            >
              <MdKeyboardBackspace />
            </span>
            Your Shopping Cart
          </p>
        </div>
        <div className='panel-body'>
          {cartData && cartData.items.length > 0 ? (
            <div className='cart-items'>
              {cartData.items.map((item) => (
                <CartItem
                  key={item.id}
                  item={item}
                  onUpdateItem={onUpdateItem}
                />
              ))}
            </div>
          ) : (
            <p>Cart is empty!</p>
          )}
        </div>
        {cartData && cartData.items.length > 0 && (
          <div className='panel-bottom'>
            <div className='cart-attribute__field'>
              <p>Where do we donate the profits from your order?</p>
              <div className='field-group'>
                <input
                  type='radio'
                  id="donate-option1"
                  name='attributes[Where should we donate 50% of the profit from your order?]'
                  value='Donate masks to frontline healthcare workers through GetUsPPE.org'
                  onChange={onChangeAttribute}
                  checked={
                    donateOption ===
                    'Donate masks to frontline healthcare workers through GetUsPPE.org'
                  }
                />
                <label for="donate-option1">Donate masks to frontline healthcare workers</label>
              </div>
              <div className='field-group'>
                <input
                  type='radio'
                  id="donate-option2"
                  name='attributes[Where should we donate 50% of the profit from your order?]'
                  value='The Los Angeles LGBT Center'
                  onChange={onChangeAttribute}
                  checked={donateOption === 'The Los Angeles LGBT Center'}
                />
                <label for="donate-option2">The Los Angeles LGBT Center</label>
              </div>
              <div className='field-group'>
                <input
                  type='radio'
                  id="donate-option3"
                  name='attributes[Where should we donate 50% of the profit from your order?]'
                  value='L.A. CADA’s Priority Access Diversion Program'
                  onChange={onChangeAttribute}
                  checked={donateOption === 'L.A. CADA’s Priority Access Diversion Program'}
                />
                <label for="donate-option3">L.A. CADA’s Priority Access Diversion Program</label>
              </div>
              <br/>

              <a href='/pages/charities' target='_blank'>
                Click here to learn more about our charities
              </a>
            </div>

            <div className='subtotal'>
              <p>Subtotal</p>
              <p>${cartData.total_price / 100}</p>
            </div>
            <p>Shipping, taxes, and discounts calculated at checkout.</p>

            <div
              className={`btn-checkout-wrapper ${
                !!cartData.attributes[
                  'Where should we donate 50% of the profit from your order?'
                ]
                  ? ''
                  : 'disabled'
              }`}
            >
              <a
                className={`btn-checkout ${
                  !!cartData.attributes[
                    'Where should we donate 50% of the profit from your order?'
                  ]
                    ? ''
                    : 'disabled'
                }`}
                href='/checkout'
              >
                Checkout
              </a>
            </div>
          </div>
        )}
      </SlidingPanel>
    </div>
  )
}

export default CartPopup
